module.exports = __webpack_public_path__ + "img/icon_map_2_5_yj.ceb894e7.png";